import { ReactNode } from 'react'
import { Link } from 'react-router'

import { RelatedItemArrowIcon } from 'app/common/presentation/icons'

import { CodeTag } from 'components'

import styles from './RelatedItem.module.scss'

interface RelatedItemProps {
  name: string
  icon?: ReactNode
  description?: ReactNode
  codeTag?: string
  to?: string
}

const RelatedItem = ({ name, icon, description, codeTag, to }: RelatedItemProps) => {
  const content = (
    <>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.content}>
        <span className={styles.text}>
          <span>{name}</span>
          {description && <span className={styles.description}>{description}</span>}
        </span>
        {codeTag && <CodeTag color="grey">{codeTag}</CodeTag>}
      </span>
      {to && (
        <span className={styles.arrow} aria-hidden="true">
          <RelatedItemArrowIcon />
        </span>
      )}
    </>
  )

  return to ? (
    <Link className={styles.item} to={to}>
      {content}
    </Link>
  ) : (
    <div className={styles.item}>{content}</div>
  )
}

export default RelatedItem
